export const transition = {
    duration: .25,
    ease: [.56, .03, .12, 1.04]
};

export const variants = {
    hideMenu: {
        opacity: 0,
        x: '-101%',
        boxShadow: '0px 0px 0px rgba(0,0,0,.15)',
    },
    showMenu: {
        opacity: 1,
        x: 0,
        boxShadow: '2px 0 5px rgba(0,0,0,.15)'
    }
}